import { render, staticRenderFns } from "./viewerBIMModule.vue?vue&type=template&id=c2c4a5ae&scoped=true"
import script from "./viewerBIMModule.vue?vue&type=script&lang=js"
export * from "./viewerBIMModule.vue?vue&type=script&lang=js"
import style0 from "./viewerBIMModule.vue?vue&type=style&index=0&id=c2c4a5ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c4a5ae",
  null
  
)

export default component.exports